import './UnitBoxes.scss';
import PropTypes from 'prop-types';

const UnitBoxes = ({ backgroundColor, color, children }) => (
  <div
    className="unit-boxes"
    style={{
      backgroundColor: `${backgroundColor}`,
      color: `${color}`
    }}
  >
    {children}
  </div>
);

UnitBoxes.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node.isRequired
};

UnitBoxes.defaultProps = {
  backgroundColor: '#646464',
  color: '#000'
};

export default UnitBoxes;
